<template>
	<div>
		<common-tab :list="tabList"></common-tab>
		<div id="party" v-show="tabId == 1">
			<div class="content" v-show="contentShow">
				<div v-html="content"></div>
			</div>
			<div v-show="!contentShow" style="color: #5f5b5b; font-size: 20px">暂无内容</div>
		</div>
		<div v-show="tabId == 2">
			<partfile :tabId="tabId"></partfile>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import CommonTab from '@/components/CommonTab.vue'
import File from './File.vue'
export default {
	components: {
		commonTab: CommonTab,
		partfile: File,
	},
	data() {
		return {
			content: '',
			contentShow: true,
			tabId: 1,
			tabList: [
				{ title: '党史介绍', name: '1' },
				{ title: '党史文件', name: '2' },
			],
		}
	},
	methods: {
		onLoad() {
			this.vaxios.get(
				`${this.vaxios.host}/open/api/v1/party-histories/status/published`,
				{ communityId: this.communityId },
				(res) => {
					if (res.data) {
						this.content = res.data.content
						this.contentShow = true
					} else {
						this.contentShow = false
					}
				},
				function(err) {
					console.log(err)
				}
			)
		},
	},
	watch: {
		communityId() {
			this.onLoad()
		},
	},
	created() {
		this.communityId.length > 0 && this.onLoad()
	},
	computed: {
		...mapGetters(['token', 'userId', 'communityId']),
	},
}
</script>

<style>
#party {
	background-color: #f5f5f5;
	padding-top: 0.75rem;
}

.content {
	padding: 0.325rem 0.75rem;
	background-color: #ffffff;
}
</style>
